import React from 'react';
import ReactDOM from 'react-dom/client';
import GymManagementApp from './App';
import LandingPage from './LandingPage';
import LoginPage from './LoginPage';
import './index.css';


const getPage = () => {
  if (window.location.pathname === '/login' || window.location.hash === '#/login') {
    return <LoginPage />;
  }
  if (window.location.pathname === '/dashboard' || window.location.hash === '#/dashboard') {
    // Check for user in localStorage
    const user = localStorage.getItem('gympro_user');
    if (!user) {
      window.location.href = '/login';
      return null;
    }
    return <GymManagementApp />;
  }
  return <LandingPage />;
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {getPage()}
  </React.StrictMode>
);